import React from "react";
import Header from "./Header";
import MobileNav, { NavItem } from "./MobileNav";
import ProfileMenu from "./ProfileMenu";

interface PortalNavProps {
    logoHref?: string;
    navItems?: NavItem[];
    userDisplayName?: string;
    profileMenuItems?: React.ReactNode;
    mobileNav?: React.ReactNode;
    showProfile?: boolean;
    backgroundColor?: string;
    profileImageSrc?: string;
    showBottomBorder?: boolean;
}

const PortalNav = ({
    logoHref,
    navItems = [],
    userDisplayName,
    profileMenuItems,
    mobileNav,
    showProfile = false,
    backgroundColor = "base.300",
    profileImageSrc,
    showBottomBorder = true
}: PortalNavProps) => {
    const hasMenuItems = Boolean(profileMenuItems &&
        (React.isValidElement(profileMenuItems) ||
         (Array.isArray(profileMenuItems) && profileMenuItems.length > 0) ||
         (typeof profileMenuItems === "string" && profileMenuItems.trim().length > 0)));

    const profileMenu =
        showProfile && userDisplayName ? (
            <ProfileMenu
                displayName={userDisplayName}
                profileImageSrc={profileImageSrc}
                hasMenuItems={hasMenuItems}
            >
                {profileMenuItems}
            </ProfileMenu>
        ) : null;

    const defaultMobileNav =
        navItems.length > 0 ? (
            <MobileNav
                navItems={navItems}
                userDisplayName={userDisplayName}
                profileMenuItems={profileMenuItems}
                showProfile={showProfile}
            />
        ) : null;

    return (
        <Header
            logoHref={logoHref}
            navItems={navItems}
            profileMenu={profileMenu}
            mobileNav={mobileNav || defaultMobileNav}
            backgroundColor={backgroundColor}
            showBottomBorder={showBottomBorder}
        />
    );
};

export default PortalNav;
